import { useUI } from '../../UIContext';
import './message.css';
import { useEffect } from "react";

function Message({ type, text, duration = 3000 }) {
    const { setMessage } = useUI();

    useEffect(() => {
        const timer = setTimeout(() => {
            setMessage(null);
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, setMessage]);

    return (
        <div className={`toast toast-${type}`}>
            {text}
        </div>
    );
}

export default Message;